export const queryWithoutParam = (urlParams: URLSearchParams, key: string): string => {
  // Don't edit the original URLSearchParams object
  const urlParamsCopy = new URLSearchParams(urlParams.toString());
  urlParamsCopy.delete(key);
  const asString = urlParamsCopy.toString();
  return asString && `?${urlParamsCopy.toString()}`;
};
